<template>
  <div>
    <div class="is-pulled-right">
      <router-link
        :to="{ name: 'patient-edit', params: { id: patient.id } }"
        class="no-print"
        >&laquo; Back to Patient
      </router-link>
    </div>
    <h1 class="title">
      {{ patient.attributes.firstName }} {{ patient.attributes.lastName }}
    </h1>

    <p><strong>Location:</strong> {{ patient.attributes.location }}</p>

    <p><strong>Status:</strong> {{ statusList[patient.attributes.status] }}</p>

    <p>
      <strong>Submitted:</strong> {{ patient.attributes.createdAt | date }}

      <br />
      <br />
    </p>

    <h2 class="subtitle">Demographics</h2>
    <p>
      <strong>Full Name:</strong> {{ patient.attributes.firstName }}
      {{ patient.attributes.lastName }}
    </p>

    <p>
      <strong>Email:</strong>
      {{ patient.attributes.email }}
    </p>

    <p>
      <strong>Phone:</strong>
      {{ patient.attributes.phone }}
    </p>

    <p>
      <strong>City:</strong>
      {{ patient.attributes.city }}
    </p>

    <p>
      <strong>State:</strong>
      {{ patient.attributes.state }}
    </p>

    <p>
      <strong>Zip:</strong>
      {{ patient.attributes.zip }}
    </p>

    <p><strong>Patient Score:</strong> {{ patient.attributes.score }}%</p>

    <p><strong>Notes:</strong> {{ patient.attributes.notes }}</p>

    <br />
    <br />

    <h2 class="subtitle">Recap</h2>

    <div
      class="interview mb1"
      v-for="question in Object.values(interview)"
      :key="question.id"
    >
      <p>
        <strong>{{ question.attributes.question.title }}</strong>
      </p>
      <div class="a mb1">
        <div
          v-if="question.attributes.kind === 'file'"
          class="file-question-answer"
        >
          <div class="columns">
            <div
              class="column pointer"
              v-for="image in question.attributes.answer"
              :key="image.url"
              @click="showModal(image)"
            >
              <img
                v-if="$isImage(image)"
                :src="image.url"
                alt="image"
                width="150"
              />
              <i v-if="!$isImage(image)" class="fa fa-file"></i>
              <p>{{ image.name }}</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="question.attributes.kind === 'instruction'"
          class="instruction-question-answer"
        >
          <div class="columns">
            <div class="column" v-if="getInstructionName(question)">
              <h4>Name</h4>
              {{ getInstructionName(question) }}
            </div>
            <div
              class="column"
              v-if="getInstructionAcceptedAgreement(question)"
            >
              <h4>Accepted Agreement</h4>
              <label class="accepted-agreement mb1">
                <input
                  type="checkbox"
                  checked="checked"
                  value="1"
                  disabled="true"
                />
                <span
                  v-if="question.attributes.question.meta.customAgreementText"
                  >{{
                    question.attributes.question.meta.customAgreementText
                  }}</span
                >
                <span v-else>I Agree</span>
              </label>
            </div>
            <div class="column" v-if="getSignature(question)">
              <h4>Signature</h4>
              <img :src="getSignature(question).data" alt="image" width="150" />
            </div>
            <div class="column" v-if="getSignatureDate(question)">
              <h4>Signature Date</h4>
              <p>{{ getSignatureDate(question) }}</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="question.attributes.kind === 'visuwell_user'"
          class="visuwell_user-question-answer"
        >
          <div class="columns">
            <div class="column">
              <h4>Organization ID</h4>
              {{ _get(question, "attributes.answer.organizationId") || "N/A" }}
              <h4>Organization Location ID</h4>
              {{
                _get(
                  question,
                  "attributes.answer.organizationLocationId" || "N/A"
                )
              }}
              <h4>MRN</h4>
              {{
                _get(
                  question,
                  "attributes.answer.emrPatientIdentifier" || "N/A"
                )
              }}
              <h4>Last Name</h4>
              {{ _get(question, "attributes.answer.lastName" || "N/A") }}
              <h4>Date of Birth</h4>
              {{ _get(question, "attributes.answer.dateOfBirth" || "N/A") }}
              <h4>Visuwell User ID</h4>
              {{ _get(question, "attributes.answer.userId" || "N/A") }}
            </div>
          </div>
        </div>

        <div
          v-else-if="
            isArray(question.attributes.answer) &&
              question.attributes.answer.length
          "
        >
          <div v-if="isChoice(question.attributes.answer[0])">
            <div
              v-for="choice in question.attributes.answer"
              :key="choice.value"
            >
              {{ choice.value }}
            </div>
          </div>
          <div v-if="!isChoice(question.attributes.answer[0])">
            <div v-for="choice in question.attributes.answer" :key="choice">
              {{ choice }}
            </div>
          </div>
        </div>

        <div v-else-if="isObject(question.attributes.answer)">
          <div v-for="value in values(question.attributes.answer)" :key="value">
            {{ value }}
          </div>
        </div>

        <div v-else-if="typeof question.attributes.answer === 'string'">
          {{ question.attributes.answer }}
        </div>

        <div v-if="!question.attributes.answer">
          _ _ _ _ _ _ _ _ _ _ _ _ _ _
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "patient-print",

  props: ["id"],

  computed: {
    patient() {
      return this.$store.getters["patientQueue/patient"](this.$props.id);
    },
    interview() {
      return this.$store.getters["patientQueue/interview"];
    },
    statusList() {
      return this.$store.getters["patientQueue/statusList"];
    }
  },

  mounted() {
    this.$store.dispatch("isPrinting").then(() => {
      window.print();
    });
  },

  methods: {
    _get(object, keyPath) {
      return _.get(object, keyPath);
    },
    getSignature(question) {
      return _.get(question, "attributes.answer.signature");
    },
    getSignatureDate(question) {
      return _.get(question, "attributes.answer.signatureDate");
    },
    getInstructionName(question) {
      return _.get(question, "attributes.answer.name");
    },
    getInstructionAcceptedAgreement(question) {
      return _.get(question, "attributes.answer.acceptedAgreement");
    },
    isArray(answer) {
      return _.isArray(answer);
    },
    isObject(answer) {
      return _.isObject(answer) && !_.isArray(answer);
    },
    values(answer) {
      return _.values(answer);
    },
    isChoice(answer) {
      return _.has(answer, "value");
    }
  }
};
</script>

<style lang="scss" scoped></style>
